import ajaxSettingsForm from '../scripts/ajaxSettingsForm';

export default function (el) {
    return {
        el,
        data() {
            const data = JSON.parse(el.getAttribute('data'));

            // Select the first tab on the left by default ("Connection")
            data.activeTab = 0;

            return data;
        },
        methods: {
            ajaxUpdateSettings(ajaxSettingsFormInjection = null) {
                this.loading = true;
                this.notices = [];

                let formHandler = ajaxSettingsFormInjection || ajaxSettingsForm;

                return formHandler().then((data) => {
                    if (data.notices) {
                        this.notices = data.notices;
                    }

                    this.api_url = data.api_url;
                    this.api_key = data.api_key;
                    this.abcart_wait = data.abcart_wait;
                    this.optin_checkbox_text = data.optin_checkbox_text;
                    this.checkbox_display_option = data.checkbox_display_option;

                    this.loading = false;
                }).catch((error) => {
                    if (error.errors) {
                        this.notices = error.errors;
                    }

                    this.api_url = error.api_url;
                    this.api_key = error.api_key;
                    this.abcart_wait = error.abcart_wait;
                    this.optin_checkbox_text = error.optin_checkbox_text;
                    this.checkbox_display_option = error.checkbox_display_option;

                    this.loading = false;
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./admin/src/js/components/RootApp.js